module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('div', {
    staticClass: "lead-form"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('div', {
    staticClass: "header-image",
    style: ({
      'background-image': 'url(' + _vm.headerImage + ')'
    })
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.fbPage.picture,
      "width": "74",
      "height": "74"
    }
  }), _c('h6', [_vm._v(_vm._s(_vm.fbPage.name))]), _c('p', {
    staticClass: "call-to-action"
  }, [_vm._v("Sign up by providing your info below.")])]), (_vm.isLeadQuestionVisible) ? _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "question"
  }, [_vm._v(_vm._s(_vm.question))]), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t("pos.postPreview.lead-form.placeholder.enquiry"),
      "disabled": true
    }
  })], 1) : _vm._e(), _vm._l((_vm.inputFields), function(label) {
    return _c('div', {
      staticClass: "form-container"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("underscoreToSpace")(label)))]), _c('b-form-input', {
      attrs: {
        "placeholder": _vm.$t(("pos.postPreview.lead-form.placeholder." + (label.toLowerCase()))),
        "disabled": true
      }
    })], 1)
  }), _c('p', {
    staticClass: "agreement"
  }, [_vm._v("By clicking Submit, you agree to send your info to " + _vm._s(_vm.fbPage.name) + " who agrees to use it according to their\nprivacy policy and the above Terms. Facebook will also use it subject to our Data Policy, including to\nauto-fill forms for ads. "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Facebook Data Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View " + _vm._s(_vm.fbPage.name) + "`s Privacy Policy")])])], 2), _c('div', {
    staticClass: "button-container"
  }, [_c('b-button', [_vm._v("Back")]), _c('b-button', {
    staticClass: "submit"
  }, [_vm._v("Submit")])], 1)])]), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('div', {
    staticClass: "lead-form"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('div', {
    staticClass: "header-image",
    style: ({
      'background-image': 'url(' + _vm.headerImage + ')'
    })
  }), _c('h6', [_c('span', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.fbPage.picture + ')'
    })
  }, [_vm._v(_vm._s(_vm.fbPage.name))])]), _c('p', {
    staticClass: "call-to-action"
  }, [_vm._v(_vm._s(_vm.$t("pos.postPreview.lead-form.thank_you_page.title")))]), _c('p', {
    staticClass: "done-message"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.thank_you_page.message')))])])]), _c('div', {
    staticClass: "button-container"
  }, [_c('b-button', {
    staticClass: "check-out"
  }, [_vm._v(_vm._s(_vm.$t("pos.postPreview.lead-form.thank_you_page.button_text")))])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d990b12a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lead-form-preview/LeadFormPreview.vue
// module id = 967
// module chunks = 1